import TagManager from 'react-gtm-module';
export const useAnalyticsManager = () => {
    return {
        trigger(eventName, args) {
            TagManager.dataLayer({ dataLayer: { event: eventName, ...args } });
        },
    };
};
